/** Neutral list action — distinct from colored status badges. */
export const ORDER_LIST_ACTION_CLASS =
  'inline-flex items-center gap-1 text-[11px] font-medium border border-gray-200 bg-white text-gray-700 px-2 py-1 rounded-lg cursor-pointer whitespace-nowrap hover:bg-gray-50 disabled:opacity-60 flex-shrink-0';
